/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const searchActorPredicateActorUuidsMax = 20;

export const searchActorPredicateActorsMax = 20;

export const searchActorPredicateEdgeTypesMax = 3;

export const searchActorPredicateQueryMax = 200;

export const SearchActorPredicate = zod.object({
  actorUuids: zod
    .array(zod.uuid())
    .min(1)
    .max(searchActorPredicateActorUuidsMax)
    .optional()
    .describe('Explicit principal actor UUIDs to match (match ANY)'),
  actors: zod
    .array(
      zod.object({
        actorUuid: zod.uuid().describe('UUID v4 identifier'),
        match: zod.enum(['SELF', 'IN_SCOPE', 'ANY']),
      }),
    )
    .min(1)
    .max(searchActorPredicateActorsMax)
    .optional()
    .describe(
      'Actors with an explicit match: SELF (unscoped principal), IN_SCOPE (scoped to the actor) or ANY',
    ),
  edgeTypes: zod
    .array(zod.enum(['AUTHORED_BY', 'SHARED_WITH', 'SUBJECT_OF']))
    .min(1)
    .max(searchActorPredicateEdgeTypesMax)
    .describe(
      'Relations to match: AUTHORED_BY (author), SHARED_WITH, and\/or SUBJECT_OF (who the content is about)',
    ),
  query: zod
    .string()
    .min(1)
    .max(searchActorPredicateQueryMax)
    .optional()
    .describe(
      'Identify a user by what you can read of their profile: a case-insensitive, literal substring of a value in it (name, email, phone). Parts of a profile you cannot read never match; your own profile and login email always do. INSTANCE mode only.',
    ),
});

export type SearchActorPredicate = zod.input<typeof SearchActorPredicate>;
export type SearchActorPredicateOutput = zod.output<typeof SearchActorPredicate>;
